import { createContext } from "react";
import type { BreadcrumbItem } from "@/shell/Breadcrumbs";

export interface BreadcrumbContextValue {
  items: BreadcrumbItem[];
  setItems: (items: BreadcrumbItem[]) => void;
}

export const BreadcrumbContext = createContext<BreadcrumbContextValue | null>(
  null,
);
